







































import { Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { ComponentBase } from '../components';
import * as common from '../common';
import { dictDefinitions } from './common';
import type { DictDefinition } from './common';


const translates = {
    get dictList(): string {
        return i18n.choose(
            'Список справочников',
            'Анықтамалық әдебиеттер тізімі',
            'List of reference books',
        );
    },
    get misc(): string {
        return i18n.choose(
            'Разное',
            'Әр түрлі',
            'Miscellaneous',
        );
    },
    get noRights(): string {
        return i18n.choose(
            'У текущего пользователя нет уровня доступа "Админ" для модуля "Штатное расписание"',
            'Ағымдағы пайдаланушыда «Қызметкерлер» модулі үшін «Әкімші» қатынасу деңгейі жоқ',
            'The current user does not have the "Admin" access level for the "Staffing" module',
        );
    },
    get reportColumnHierarchy(): string {
        return i18n.choose(
            'Иерархия колонок отчетов',
            'Есептер есептерінің иерархиясы',
            'Report column hierarchy',
        );
    },
};


@Component
export default class Page extends ComponentBase {
    constructor() {
        super('');
    }


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private get isAdmin(): boolean {
        return common.staffTabAccess.isAdmin;
    }
    // endregion


    // region Справочники
    private get dictList(): Array<DictDefinition> {
        const locale = i18n.locale;
        return [...dictDefinitions].sort((a, b) => {
            return a.title.localeCompare(b.title, locale);
        });
    }
    // endregion
}
